<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <!-- 主表单区域 -->
      <a-form-model :model="model" :rules="validatorRules" ref="form" slot="detail">
        <a-row>
          <a-col :span="8">
            <a-form-model-item :labelCol="labelCol3" :wrapperCol="wrapperCol3" label="名称" prop="modelName">
              <a-input placeholder="请输入名称" v-model="model.modelName"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :labelCol="labelCol3" :wrapperCol="wrapperCol3" label="生产厂家" prop="manuId">
              <j-search-select-tag
                dict="`iwt-wf`.common_manufacturer,manu_name,id, 1=1 order by manu_name asc"
                placeholder="请选择生产厂家"
                v-model="model.manuId"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :labelCol="labelCol3" :wrapperCol="wrapperCol3" label="型号编码" prop="modelCode">
              <a-input placeholder="请输入型号编码" v-model="model.modelCode"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12" v-show="false">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="测点数量" prop="pointCount">
              <a-input-number disabled style="width: 100%" v-model="model.pointCount" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="产品规格" prop="modelSpecification">
              <j-editor v-model="model.modelSpecification" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品文档" prop="modelDoc">
              <j-upload v-model="model.modelDoc"></j-upload>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="照片" prop="pictureObjId">
              <j-image-upload isMultiple v-model="model.pictureObjId"></j-image-upload>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="在线图标" prop="iconOnlineUrl">
              <j-image-upload v-model="model.iconOnlineUrl"></j-image-upload>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="离线图标" prop="iconOfflineUrl">
              <j-image-upload v-model="model.iconOfflineUrl"></j-image-upload>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="告警图标" prop="iconAlertUrl">
              <j-image-upload v-model="model.iconAlertUrl"></j-image-upload>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
    <!-- 子表单区域 -->
    <a-tabs @change="handleChangeTabs" v-model="activeKey">
      <a-tab-pane :forceRender="true" :key="refKeys[0]" tab="传感器采集点定义">
        <j-editable-table
          :actionButton="true"
          :columns="iotSensorPointsDefTable.columns"
          :dataSource="iotSensorPointsDefTable.dataSource"
          :disabled="formDisabled"
          :loading="iotSensorPointsDefTable.loading"
          :maxHeight="300"
          :ref="refKeys[0]"
          :rowNumber="true"
          :rowSelection="true"
        />
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>

<script>
  import { getAction } from '@/api/manage'
  import { FormTypes, getRefPromise, VALIDATE_NO_PASSED } from '@/utils/JEditableTableUtil'
  import { JEditableTableModelMixin } from '@/mixins/JEditableTableModelMixin'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'IotSensorModelForm',
    mixins: [JEditableTableModelMixin],
    components: {},
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 }
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 }
        },
        labelCol3: {
          xs: { span: 24 },
          sm: { span: 9 }
        },
        wrapperCol3: {
          xs: { span: 24 },
          sm: { span: 14 }
        },
        model: {},
        // 新增时子表默认添加几行空数据
        addDefaultRowNum: 1,
        validatorRules: {
          modelName: [{ required: true, message: '请输入名称!' }],
          modelCode: [{ required: true, message: '请输入型号编码!' }],
          manuId: [{ required: true, message: '请输入生产厂家!' }]
        },
        refKeys: ['iotSensorPointsDef'],
        tableKeys: ['iotSensorPointsDef'],
        activeKey: 'iotSensorPointsDef',
        // 传感器采集点定义
        iotSensorPointsDefTable: {
          loading: false,
          dataSource: [],
          columns: [
            // {
            //   title: '传感器类型',
            //   key: 'sensorModelId',
            //   type: FormTypes.select,
            //   dictCode: '`iwt-wf`.iot_sensor_model,model_name,id',
            //   width: '200px',
            //   placeholder: '请输入${title}',
            //   defaultValue: ''
            // },
            {
              title: '采集点名称',
              key: 'pointName',
              type: FormTypes.input,
              width: '100px',
              placeholder: '请输入${title}',
              defaultValue: '',
              validateRules: [{ required: true, message: '${title}不能为空' }]
            },
            {
              title: '简写',
              key: 'shortName',
              type: FormTypes.input,
              width: '100px',
              placeholder: '请输入${title}',
              defaultValue: ''
            },
            {
              title: '采集点编码',
              key: 'pointCode',
              type: FormTypes.input,
              width: '100px',
              placeholder: '请输入${title}',
              defaultValue: '',
              validateRules: [{ required: true, message: '${title}不能为空' }]
            },
            {
              title: '测点类型',
              key: 'dataType',
              type: FormTypes.select,
              dictCode: 'point_data_type',
              width: '100px',
              placeholder: '请输入${title}',
              defaultValue: '',
              validateRules: [{ required: true, message: '${title}不能为空' }]
            },
            {
              title: '计量单位',
              key: 'dataUnit',
              type: FormTypes.input,
              width: '80px',
              placeholder: '请输入${title}',
              defaultValue: ''
            },
            {
              title: '倍率',
              key: 'multi',
              type: FormTypes.inputNumber,
              width: '80px',
              placeholder: '请输入${title}',
              defaultValue: '1'
            },
            {
              title: '偏移',
              key: 'shift',
              type: FormTypes.inputNumber,
              width: '80px',
              placeholder: '请输入${title}',
              defaultValue: '0'
            },
            {
              title: '上限',
              key: 'toprange',
              type: FormTypes.inputNumber,
              width: '100px',
              placeholder: '请输入${title}',
              defaultValue: ''
            },
            {
              title: '下限',
              key: 'bottomrange',
              type: FormTypes.inputNumber,
              width: '100px',
              placeholder: '请输入${title}',
              defaultValue: ''
            }
            // {
            //   title: '信号分类',
            //   key: 'pointClassCode',
            //   type: FormTypes.select,
            //   dictCode: '',
            //   width: '200px',
            //   placeholder: '请输入${title}',
            //   defaultValue: ''
            // },
            // {
            //   title: '告警规则',
            //   key: 'alertRule',
            //   type: FormTypes.input,
            //   width: '200px',
            //   placeholder: '请输入${title}',
            //   defaultValue: ''
            // }
          ]
        },
        url: {
          add: '/monitor/sensorModel/add',
          edit: '/monitor/sensorModel/edit',
          queryById: '/monitor/sensorModel/queryById',
          iotSensorPointsDef: {
            list: '/monitor/sensorModel/queryIotSensorPointsDefByMainId'
          }
        }
      }
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      }
    },
    created () { },
    methods: {
      addBefore () {
        this.iotSensorPointsDefTable.dataSource = []
      },
      getAllTable () {
        let values = this.tableKeys.map(key => getRefPromise(this, key))
        return Promise.all(values)
      },
      /** 调用完edit()方法之后会自动调用此方法 */
      editAfter () {
        this.$nextTick(() => { })
        // 加载子表数据
        if (this.model.id) {
          let params = { id: this.model.id }
          this.requestSubTableData(this.url.iotSensorPointsDef.list, params, this.iotSensorPointsDefTable)
        }
      },
      //校验所有一对一子表表单
      validateSubForm (allValues) {
        return new Promise((resolve, reject) => {
          Promise.all([])
            .then(() => {
              resolve(allValues)
            })
            .catch(e => {
              if (e.error === VALIDATE_NO_PASSED) {
                // 如果有未通过表单验证的子表，就自动跳转到它所在的tab
                this.activeKey = e.index == null ? this.activeKey : this.refKeys[e.index]
              } else {
                console.error(e)
              }
            })
        })
      },
      /** 整理成formData */
      classifyIntoFormData (allValues) {
        let main = Object.assign(this.model, allValues.formValue, { pointCount: allValues.tablesValue[0].values.length })
        return {
          ...main, // 展开
          iotSensorPointsDefList: allValues.tablesValue[0].values
        }
      },
      validateError (msg) {
        this.$message.error(msg)
      }
    }
  }
</script>

<style scoped>

</style>
